import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { makeStyles } from "@material-ui/core";

import Header from "./Header";
import RouterIsthia from "./RouterIsthia";
import Footer from "./Footer";

const useStyles = makeStyles((theme) => ({
  mainTemplate: {
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    minHeight: "100vh",
    maxWidth: 480,
    margin: "auto",
    backgroundColor: "#eeeeee",
  },
}));

const Isthia = () => {
  const classes = useStyles();

  return (
    <Router basename="/nattur/">
      <div className={classes.mainTemplate}>
        <Header />
        <main>
          <RouterIsthia />
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default Isthia;
